export var Provider;
(function (Provider) {
    Provider["Aws"] = "AWS";
    Provider["Azure"] = "AZURE";
    Provider["Gcp"] = "GCP";
    Provider["MongoAtlas"] = "MONGO_ATLAS";
    Provider["ProviderUnspecified"] = "PROVIDER_UNSPECIFIED";
})(Provider || (Provider = {}));
